import { APP_CONFIG } from "@config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../hooks/helpers";
import { getGuestToken } from "./guestToken";

export const baseApi = createApi({
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  reducerPath: "kiralasakApi",
  baseQuery: fetchBaseQuery({
    baseUrl: APP_CONFIG.API_URL,
    prepareHeaders: async (headers, { getState }: any) => {
      // Kullanıcı token'ı yoksa misafir token'ı ile devam edilir; backend
      // /User/Login dahil her uçta geçerli bir Bearer token bekliyor.
      const token = getToken(getState().auth) ?? (await getGuestToken());

      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: () => ({}),
});
